import type React from 'react';
import { IndividualRegistrationForm } from '@/components/auth/individual-registration-form';

export const RegisterIndividual: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <IndividualRegistrationForm onBack={() => window.history.back()} />
    </div>
  );
};
